/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  if (window.__elppisMoqQuantity) {
    return;
  }

  window.__elppisMoqQuantity = true;

  var minimumQuantity = 6;
  var quantityStep = 6;

  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getMinimum(input) {
    return toNumber(input.getAttribute('data-min') || input.getAttribute('min'), minimumQuantity);
  }

  function getStep(input) {
    return toNumber(input.getAttribute('data-quantity-step') || input.getAttribute('step'), quantityStep);
  }

  function getMaximum(input) {
    return toNumber(input.getAttribute('data-max') || input.getAttribute('max') || input.getAttribute('data-quantity-max'), 0);
  }

  function isQuantityInput(input) {
    return Boolean(input) && (
      input.matches('[data-quantity-field]') ||
      input.name === 'quantity' ||
      input.name === 'updates[]'
    );
  }

  function normalizeQuantity(value, input) {
    var min = getMinimum(input);
    var step = getStep(input);
    var quantity = toNumber(value, min);

    if (quantity < min) {
      quantity = min;
    }

    var remainder = quantity % step;
    if (remainder !== 0) {
      quantity += step - remainder;
    }

    var max = getMaximum(input);
    if (max > 0 && quantity > max) {
      quantity = Math.floor(max / step) * step;
      if (quantity < min) {
        quantity = min;
      }
    }

    return quantity;
  }

  function syncQuantityText(input) {
    var roots = [
      input.closest('[data-quantity-wrapper]'),
      input.closest('[data-quantity-holder]'),
      input.closest('[data-cart-bar-qty]'),
      input.closest('.cart__item__bottom')
    ].filter(Boolean);

    roots.forEach(function(root) {
      root.querySelectorAll('[data-quantity-select]').forEach(function(text) {
        text.textContent = input.value;
      });
    });
  }

  function prepareQuantityInput(input) {
    if (!isQuantityInput(input)) {
      return;
    }

    input.setAttribute('data-min', String(minimumQuantity));
    input.setAttribute('data-quantity-step', String(quantityStep));
    input.setAttribute('min', String(minimumQuantity));
    input.setAttribute('step', String(quantityStep));

    var nextValue = normalizeQuantity(input.value, input);
    if (String(nextValue) !== input.value) {
      input.value = nextValue;
    }

    syncQuantityText(input);
  }

  function prepareAllQuantityInputs(root) {
    (root || document).querySelectorAll('[data-quantity-field]').forEach(prepareQuantityInput);
  }

  function dispatchQuantityChange(input) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getMoneyFormat() {
    if (!window.theme) {
      return '';
    }

    return window.theme.settings && window.theme.settings.currency_code_enable ?
      window.theme.moneyWithCurrencyFormat :
      window.theme.moneyFormat;
  }

  function formatMoney(cents) {
    if (!window.theme || typeof window.theme.formatMoney !== 'function') {
      return '';
    }

    return window.theme.formatMoney(cents, getMoneyFormat());
  }

  function getVariantFromProductInfo(productInfo) {
    var variantScript = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (variantScript && variantScript.textContent.trim()) {
      try {
        return JSON.parse(variantScript.textContent);
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function getVariantFromForm(productInfo) {
    var formWrapper = productInfo.querySelector('[data-form-wrapper]');
    if (!formWrapper || !formWrapper.dataset.variantPrice) {
      return null;
    }

    return {
      price: toNumber(formWrapper.dataset.variantPrice, 0),
      compare_at_price: toNumber(formWrapper.dataset.variantComparePrice, 0)
    };
  }

  function getCurrentVariant(productInfo) {
    return getVariantFromProductInfo(productInfo) || getVariantFromForm(productInfo);
  }

  function getProductQuantity(productInfo, sourceInput) {
    var input = sourceInput && productInfo.contains(sourceInput) && sourceInput.name === 'quantity' ?
      sourceInput :
      productInfo.querySelector('[data-form-wrapper] input[name="quantity"][data-quantity-field], input[name="quantity"][data-quantity-field]');

    return input ? normalizeQuantity(input.value, input) : minimumQuantity;
  }

  function updatePriceWrapper(wrapper, totalPrice, totalComparePrice, isOnSale) {
    var price = wrapper.querySelector('[data-product-price]');
    if (!price) {
      return;
    }

    var formattedPrice = totalPrice === 0 && window.theme && window.theme.strings ?
      window.theme.strings.free :
      formatMoney(totalPrice);

    if (formattedPrice) {
      price.innerHTML = formattedPrice;
    }

    price.classList.toggle('product__price--sale', Boolean(isOnSale));

    var comparePrice = wrapper.querySelector('[data-compare-price], .product__price--strike');
    if (!comparePrice) {
      return;
    }

    if (isOnSale && totalComparePrice > totalPrice) {
      var formattedComparePrice = formatMoney(totalComparePrice);
      if (formattedComparePrice) {
        comparePrice.innerHTML = formattedComparePrice;
      }
      comparePrice.classList.remove('hidden');
      comparePrice.style.display = '';
    } else {
      comparePrice.classList.add('hidden');
      comparePrice.style.display = 'none';
    }
  }

  function updateProductPriceTotals(productInfo, sourceInput) {
    if (!productInfo) {
      return;
    }

    var variant = getCurrentVariant(productInfo);
    if (!variant || variant.price == null) {
      return;
    }

    var quantity = getProductQuantity(productInfo, sourceInput);
    var unitPrice = toNumber(variant.price, 0);
    var unitComparePrice = toNumber(variant.compare_at_price, 0);
    var totalPrice = unitPrice * quantity;
    var totalComparePrice = unitComparePrice * quantity;
    var isOnSale = unitComparePrice > unitPrice;

    productInfo.querySelectorAll('[data-price-wrapper], .cart-bar__product__price').forEach(function(wrapper) {
      updatePriceWrapper(wrapper, totalPrice, totalComparePrice, isOnSale);
    });
  }

  function updateAllProductPriceTotals(root) {
    (root || document).querySelectorAll('product-info').forEach(function(productInfo) {
      updateProductPriceTotals(productInfo);
    });
  }

  function queueProductPriceUpdate(target) {
    var productInfo = target && target.closest ? target.closest('product-info') : null;
    window.requestAnimationFrame(function() {
      if (productInfo) {
        updateProductPriceTotals(productInfo, target);
      } else {
        updateAllProductPriceTotals(document);
      }
    });
  }

  document.addEventListener('click', function(event) {
    var plusButton = event.target.closest('[data-quantity-plus]');
    var minusButton = event.target.closest('[data-quantity-minus]');

    if (!plusButton && !minusButton) {
      return;
    }

    var holder = event.target.closest('[data-quantity-holder]');
    var input = holder && holder.querySelector('[data-quantity-field]');

    if (!input) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    prepareQuantityInput(input);

    var min = getMinimum(input);
    var step = getStep(input);
    var max = getMaximum(input);
    var quantity = normalizeQuantity(input.value, input);
    var nextQuantity = plusButton ? quantity + step : quantity - step;

    if (nextQuantity < min) {
      nextQuantity = min;
    }

    if (max > 0 && nextQuantity > max) {
      nextQuantity = normalizeQuantity(max, input);
    }

    input.value = nextQuantity;
    syncQuantityText(input);
    dispatchQuantityChange(input);
    queueProductPriceUpdate(input);
  }, true);

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-quantity-field]')) {
      return;
    }

    var input = event.target;
    var nextValue = normalizeQuantity(input.value, input);
    if (String(nextValue) !== input.value) {
      input.value = nextValue;
      syncQuantityText(input);
      dispatchQuantityChange(input);
    }

    queueProductPriceUpdate(input);
  });

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"], form[action*="/cart"]')) {
      return;
    }

    form.querySelectorAll('[data-quantity-field], input[name="quantity"], input[name="updates[]"]').forEach(function(input) {
      prepareQuantityInput(input);
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    prepareAllQuantityInputs(document);
    updateAllProductPriceTotals(document);
  });

  window.addEventListener('pageshow', function() {
    prepareAllQuantityInputs(document);
    updateAllProductPriceTotals(document);
  });

  document.addEventListener('theme:product-info:loaded', function(event) {
    prepareAllQuantityInputs(event.target);
    queueProductPriceUpdate(event.target);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function() {
      window.requestAnimationFrame(function() {
        prepareAllQuantityInputs(document);
        updateAllProductPriceTotals(document);
      });
    });
  }

  if (window.MutationObserver) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            prepareAllQuantityInputs(node);
            updateAllProductPriceTotals(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
